import { Injectable } from '@angular/core';

/** Focus target when opening a sibling module from Left/Right at a lane boundary. */
export type MegaPeerFocusMode = 'first' | 'lastLaneFirst';

export interface MegaBranchPeerHandle {
  readonly hostElement: HTMLElement;
  openFromPeerNav(focus: MegaPeerFocusMode): void;
}

/**
 * Tracks top-level mega menu branch hosts so ArrowLeft/ArrowRight can move to the
 * previous/next module when focus is on the first/last column.
 */
@Injectable({ providedIn: 'root' })
export class MegaMenuBranchRegistryService {
  private readonly _peers = new Map<HTMLElement, MegaBranchPeerHandle>();

  register(handle: MegaBranchPeerHandle): void {
    this._peers.set(handle.hostElement, handle);
  }

  unregister(hostElement: HTMLElement): void {
    this._peers.delete(hostElement);
  }

  /**
   * Returns the adjacent registered branch in DOM order within the horizontal nav wrapper.
   */
  getAdjacent(
    hostElement: HTMLElement,
    delta: 1 | -1,
  ): MegaBranchPeerHandle | null {
    const wrapper = hostElement.closest('.fuse-horizontal-navigation-wrapper');
    if (!wrapper) {
      return null;
    }
    const hosts = Array.from(
      wrapper.querySelectorAll<HTMLElement>('app-mega-module-menu-branch'),
    );
    const idx = hosts.indexOf(hostElement);
    if (idx < 0) {
      return null;
    }
    const j = idx + delta;
    if (j < 0 || j >= hosts.length) {
      return null;
    }
    return this._peers.get(hosts[j]) ?? null;
  }
}
